import React from 'react';
import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import autobind from 'autobind-decorator';
import { Link, withRouter } from 'react-router-dom';
import Spinner from 'components/Spinner';
import Time from 'components/Time';
import ProgressBar from 'components/ProgressBar';
import addSeconds from 'date-fns/addSeconds';

@withRouter

export default class SiteHeader extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    site: PropTypes.object,
    addSteps: PropTypes.func,
    joyrideReset: PropTypes.func,
  }

  componentDidMount() {
    const steps = [
      {
        title: 'Live site area',
        text: 'This area contains information about your live website. Remeber that your website is always online even if WordPress is switched OFF. Every page of this website is pure static HTML',
        selector: '.tour-header',
        position: 'bottom',
        type: 'hover',
      },
      {
        title: 'Static site URL',
        text: 'This is the URL where your static generated website lives. This can be changed by clicking on "configure domain" button (see next step)',
        selector: '.tour-url',
        position: 'bottom',
      },
      {
        title: 'Custom domain',
        text: 'Use this button to set your custom domain and serve the static generated website through your real domain',
        selector: '.tour-domain',
        position: 'bottom',
      },
    ];
    this.props.addSteps(steps);
  }

  @autobind
  handleHelp() {
    this.props.joyrideReset();
  }

  @autobind
  handleCloseModal() {
    const { site } = this.props;
    this.props.history.push(`/site/${site.id}`);
  }

  @autobind
  handleClosePlanModal() {
    const { site } = this.props;
    this.props.history.push(`/site/${site.id}/plan`);
  }

  renderLoading() {
    return <Spinner size={80} />;
  }

  @autobind
  renderProgressBars(site) {
    return (
      <div>
        {
          site.attributes.wpState === 'deploying' &&
            <div>
              <div className="Sites__item__details">
                Publishing site...
              </div>
              <div className="space--top-1">
                <ProgressBar
                  startedAt={site.attributes.lastDeployStartedAt}
                  expectedFinishDate={
                    addSeconds(
                      site.attributes.lastDeployStartedAt,
                      site.attributes.averageDeployTimeInSeconds,
                    ).toISOString()
                  }
                />
              </div>
            </div>
        }
        {
          site.attributes.wpState === 'loading' &&
            <div>
              <div className="Sites__item__details">
                Switching WordPress ON ...
              </div>
              <div className="space--top-1">
                <ProgressBar
                  startedAt={site.attributes.startedAt}
                  expectedFinishDate={
                    addSeconds(
                      site.attributes.startedAt,
                      site.attributes.averageStartTimeInSeconds,
                    ).toISOString()
                  }
                />
              </div>
            </div>
        }
        {
          site.attributes.wpState === 'pausing' &&
            <div>
              <div className="Sites__item__details">
                Switching WordPress OFF ...
              </div>
              <div className="space--top-1">
                <ProgressBar
                  startedAt={site.attributes.pausedAt}
                  expectedFinishDate={
                    addSeconds(
                      site.attributes.pausedAt,
                      site.attributes.averagePauseTimeInSeconds,
                    ).toISOString()
                  }
                />
              </div>
            </div>
        }
      </div>
    );
  }

  @autobind
  renderThumbnail(site) {
    return (
      <div>
        {site.attributes.screenshotUrl ?
          <div
            className="Backend__header__image"
            style={{ backgroundImage: `url(${site.attributes.screenshotUrl})` }}
          />
          :
          <div className="Backend__header__image">
            <div className="SiteHeader__item__image-placeholder">
              <Spinner />
            </div>
          </div>
        }
      </div>
    );
  }

  renderSite() {
    const { site } = this.props;

    return (
      <div>
        <div className="tour-header Backend__title space--bottom-1">
          <div className="Backend__header">
            {site.attributes.pullZoneIsReachable &&
              <a
                href={site.attributes.staticUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  { this.renderThumbnail(site) }
                </div>
              </a>
            }
            {!site.attributes.pullZoneIsReachable &&
              <div>
                { this.renderThumbnail(site) }
              </div>
            }
            <div className="Backend__header__content">
              <div className="Backend__header__name">
                {site.attributes.name}
              </div>
              {!site.attributes.pullZoneIsReachable &&
                <Tooltip label={'The changes are syncing to our CDN servers. This can take few seconds.'}>
                  <div className="tour-url Backend__header__url--disabled">
                    {site.attributes.staticUrl}
                    <Spinner inline size={20} />
                  </div>
                </Tooltip>
              }
              {site.attributes.pullZoneIsReachable &&
                <div className="tour-url Backend__header__url">
                  <a
                    href={site.attributes.staticUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {site.attributes.staticUrl}
                  </a>
                </div>
              }
              <div className="Backend__header__extra">
                { site.attributes.deployNeeded &&
                  <div className="Backend__header__extra__alert">
                    A new Deploy is needed for changes to take effect.
                  </div>
                }
                {
                  !site.attributes.deployNeeded && site.attributes.wpState !== 'deploying' && site.attributes.wpState !== 'loading' && site.attributes.wpState !== 'pausing' && site.attributes.lastDeployAt ?
                    <div>Last deploy <Time value={site.attributes.lastDeployAt} /></div>
                    :
                    <div>&nbsp;</div>
                }
                { this.renderProgressBars(site) }
              </div>
            </div>
            <div className="Backend__header__actions">
              <Link
                to={`/site/${site.id}/domain`}
                className="tour-domain button button--tiny"
              >
                Configure domain
              </Link>
              <Link
                to={`/site/${site.id}/https`}
                className={'button button--tiny'}
              >
                {site.attributes.staticDomainSsl ? 'Disable HTTPS' : 'Enable HTTPS'}
              </Link>
              <button
                className="link Backend__header__actions__help"
                onClick={this.handleHelp}
              >
                Help
              </button>
            </div>
          </div>

        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {
          this.renderSite()
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SiteHeader.jsx